export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टिकरण"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["हाँ"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्या आप वाकई जारी रखना चाहते हैं?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्रिप्टो एसेट हटाएं"])}
}